// extracted by mini-css-extract-plugin
export var accordion_header_wrapper = "index-module--accordion_header_wrapper--52501";
export var answer_wrapper = "index-module--answer_wrapper--fa36f";
export var blok_content = "index-module--blok_content--bf5fa";
export var faq_item = "index-module--faq_item--db63f";
export var faqs_container = "index-module--faqs_container--3c377";